const category = 'AdvancedSettings';

const cards = [
  {
        name: "Advanced",
        id: "advanced",
        fields: [
            [{ id: "AdvancedSettingsListGuidance" }],
            [{ id: "AdvancedSettingsList" }]
        ],
  }
];

export { cards, category };